import React, { forwardRef, isValidElement } from 'react';
import Text from '../Text';
import { SectionHeaderProps } from './SectionHeader.types';
import { st, classes } from './SectionHeader.st.css';

const SectionHeader = forwardRef<HTMLDivElement, SectionHeaderProps>(
  (
    {
      dataHook,
      title,
      suffix,
      id,
      'aria-describedby': ariaDescribedBy,
      as = 'span',
      skin = 'standard',
      size = 'medium',
      align = 'start',
      divider = 'default',
      horizontalPadding = 'large',
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        data-hook={dataHook}
        className={st(classes.root, {
          skin,
          horizontalPadding,
          divider,
          size,
        })}
      >
        <div
          className={st(classes.title, { align, horizontalPadding })}
          data-hook="title-node"
        >
          {isValidElement(title) ? (
            title
          ) : (
            <Text
              id={id}
              className={classes.titleText}
              aria-describedby={ariaDescribedBy}
              tagName={as}
              size={size}
              weight="thin"
              flip
              ellipsis
            >
              {title}
            </Text>
          )}
        </div>

        {suffix && (
          <div
            className={st(classes.suffix, { horizontalPadding })}
            data-hook="suffix-node"
          >
            {suffix}
          </div>
        )}
      </div>
    );
  },
);

SectionHeader.displayName = 'SectionHeader';

export default SectionHeader;
